import type { EntityOption, EntitySource } from './entity-source';

const labels = new Map<string, EntityOption>();
const keyOf = (source: EntitySource, value: string) => `${JSON.stringify(source.key)}:${value}`;

/**
 * Rótulos já escolhidos nesta sessão, por fonte: o chip do filtro e o campo mostram o nome do que a
 * pessoa escolheu sem nova chamada (a URL guarda só o id).
 */
export const entityOptionCache = {
  get<T>(source: EntitySource<T>, value: string): EntityOption | undefined {
    return labels.get(keyOf(source as EntitySource, value));
  },
  set<T>(source: EntitySource<T>, option: EntityOption) {
    labels.set(keyOf(source as EntitySource, option.value), option);
  },
};
